import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';

import { FloatingFieldRepeatEnum } from '@app/models';

export type ModalResult = FloatingFieldRepeatEnum;

@Component({
  selector: 'app-repeat-floating-field-modal',
  templateUrl: './repeat-floating-field-modal.component.html',
  styleUrls: ['./repeat-floating-field-modal.component.scss'],
  standalone: false
})
export class RepeatFloatingFieldModalComponent {
  form: UntypedFormGroup;
  FloatingFieldRepeatEnum = FloatingFieldRepeatEnum;

  constructor(public modal: NgbActiveModal, private formBuilder: UntypedFormBuilder) {
    this.form = this.formBuilder.group({ option: null });
  }

  apply() {
    if (typeof this.form.get('option').value === 'number') {
      this.modal.close(this.form.get('option').value as ModalResult);
    } else {
      this.modal.dismiss();
    }
  }
}
